import { getCurrentLocation, LocationInterface } from '@/utils/location';
import { hideLoader, showLoader } from '@/utils/loading';
import { showAlert } from '@/utils/alert';

export const getCurrentLocationMixin = {
    methods: {
        /**
         * @return {Promise<LocationInterface>}
         */
        getCurrentLocation(): Promise<LocationInterface> {
            showLoader();

            return getCurrentLocation()
                .catch((err) => {
                    showAlert(err.message);

                    throw err;
                })
                .finally(() => {
                    hideLoader();
                });
        },
    },
};
